import React, { useState } from "react";
import axios from "axios"; // ✅ Import axios
import {
  Box,
  IconButton,
  Drawer,
  useMediaQuery,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import "../sidebar.css";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const Cloudsidebar = () => {
  const [open, setOpen] = useState(false);

  // Filter states
  const [search, setSearch] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("All");
  const [city, setCity] = useState("");
  const [subLocation, setSubLocation] = useState("");
  const [businessModel, setBusinessModel] = useState("");

  const citySubLocations = {
    hyderabad: ["Kukatpally", "Madhapur", "Ameerpet"],
    bangalore: ["BTM", "Whitefield", "Indiranagar"],
    chennai: ["T Nagar", "Anna Nagar", "Velachery"],
    mumbai: ["Andheri", "Bandra", "Borivali"],
  };

  const isSmallMobile = useMediaQuery(theme.breakpoints.down(400));
  const isMobile = useMediaQuery(theme.breakpoints.down(600));
  const isTablet = useMediaQuery(theme.breakpoints.between(601, 960));
  const isDesktop = useMediaQuery(theme.breakpoints.up(961));



const userId = localStorage.getItem("userId");
const vendorId = localStorage.getItem("vendorId");

const handleChange = async (e) => {
  const selectedValue = e.target.value;
  setBusinessModel(selectedValue);

  if (!selectedValue) return; // prevent empty selection

  try {
    if (!userId || !vendorId) {
      alert("UserId or VendorId missing!");
      return;
    }

    // ✅ only userId in the URL
    const url = ` https://backend.maamaas.com/food/api/cart/create/${userId}`;
    
    // ✅ vendorId passed from localStorage via params
    const response = await axios.post(url, {}, {
      params: {
        orderType: selectedValue,
        vendorId: vendorId
      }
    });

    console.log("Cart created successfully:", response.data);
    alert(`Cart created for ${selectedValue}`);
  } catch (error) {
    console.error("Error creating cart:", error);
    alert("Failed to create cart");
  }
};



  const getSidebarWidth = () => {
    if (isSmallMobile) return 180;
    if (isMobile) return 200;
    if (isTablet) return 220;
    return 260;
  };

  const getIconSize = () => {
    if (isSmallMobile) return "medium";
    return "large";
  };

  const getToggleButtonLeft = () => {
    if (isDesktop) return open ? "calc(100% - 1466px)" : 70;
    if (isTablet) return open ? "calc(100% - 768px)" : 20;
    return open ? "calc(100% - 320px)" : 10;
  };

  return (
    <ThemeProvider theme={theme}>
      {/* Toggle Button */}
      {/* <Box
        sx={{
          position: "fixed",
          top: isMobile ? "70px" : "86px",
          left: getToggleButtonLeft(),
          transition: "left 0.3s ease-in-out",
          zIndex: 1500,
        }}
        className="side-data-bar"
      >
        <IconButton
          onClick={() => setOpen(!open)}
          sx={{
            color: "#B276C3",
            padding: isSmallMobile ? "8px" : "12px",
          }}
        >
          <MenuIcon fontSize={getIconSize()} />
        </IconButton>
      </Box> */}

      {/* Sidebar Drawer */}
      <Drawer
        anchor="left"
        variant={isDesktop ? "persistent" : "temporary"}
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            marginTop: isMobile ? "60px" : "80px",
            overflowY: "auto",
            height: isMobile ? "calc(100vh - 60px)" : "calc(100vh - 80px)",
            border: "3px solid white",
            width: getSidebarWidth(),
            padding: "15px",
          },
        }}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {/* Filters Sidebar */}
        <div className="filter-sidebar">
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search…"
            className="filter-input"
            style={{
              width: "170px",
              marginBottom: "10px",
              padding: "6px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              marginTop: "40px"
            }}
          />

          <select
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(e.target.value)}
            className="filter-select"
            style={{ width: "170px", marginBottom: "10px", padding: "6px", borderRadius: "6px", }}
          >
            <option value="All">Select Business Type</option>
            <option value="Restaurant">Food & Beverages</option>
            <option value="FoodCourt">Franchise</option>
            <option value="FoodTruck">Banquet Halls</option>
            <option value="CloudKitchen">Staffing</option>
          </select>

          <select
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className="filter-select"
            style={{ width: "170px", marginBottom: "10px", padding: "6px", borderRadius: "6px", }}
          >
            <option value="">Select City</option>
            <option value="Hyderabad">Hyderabad</option>
            <option value="Bangalore">Bangalore</option>
            <option value="Chennai">Chennai</option>
            <option value="Mumbai">Mumbai</option>
          </select>

          {city && (
            <select
              value={subLocation}
              onChange={(e) => setSubLocation(e.target.value)}
              className="filter-select"
              style={{ width: "170px", marginBottom: "10px", padding: "6px", borderRadius: "6px", }}
            >
              <option value="">Select Location</option>
              {citySubLocations[city.toLowerCase()]?.map((loc) => (
                <option key={loc} value={loc}>
                  {loc}
                </option>
              ))}
            </select>
          )}

          <select
            value={businessModel}
            onChange={handleChange}
            className="filter-select"
            style={{
              width: "170px",
              marginBottom: "10px",
              padding: "6px",
              borderRadius: "6px",
            }}
          >
            <option value="">Select Service</option>
            <option value="DINE_IN">Dine In</option>
            <option value="TAKEAWAY">Take Away</option>
            <option value="DELIVERY">Delivery</option>
          </select>
        </div>
      </Drawer>
    </ThemeProvider>
  );
};

export default Cloudsidebar;
